//import { act } from "@testing-library/react";
/**
 * @typedef {Object} Project
 * @property {string} id - The project id.
 * @property {string} projectName - The name of the project.
 * @property {string} databaseName - The name of the database.
 * @property {Date} createdUtcTime - The date the project was created.
 * @property {string} createdByUser - The id of the user who created the project.
 * @property {string} updatedByUser - The id of the user who last updated the project.
 * @property {boolean} disabled - Whether the project is disabled.
 * @property {string} description - A description of the project.
 * @property {boolean} statusTable_Enabled - Status table enabled flag.
 * @property {boolean} listEQ_Enabled - ListEQ enabled flag.
 * @property {string} listEQ_DataFolder - The data folder of ListEQ.
 * @property {string} depthSeries_Title - The title of the depth series.
 * @property {?number} statusDisplayKind - Status light kind.
 * @property {number} projectStatusLogicMode - 0: legacy, 1: alert/action.
 * @property {?number} projectAlertActionStatusDisplayKind - Independent alert/action style.
 * @property {boolean} isEnableValueNotify - Enable value notify flag.
 * @property {boolean} isEnableValueNotifyByLine - Enable value notify by line flag.
 * @property {boolean} isEnableValueNotifyBySms - Enable value notify by GNS SMS flag.
 * @property {boolean} isEnableValueNotifyByEmail - Enable value notify by SMTP Email flag.
 * @property {number} smsProvider - GNS SMS provider kind.
 * @property {string} lineNotifyDestination - Line notify destination.
 * @property {?string} lineBotProfileId - Selected shared LINE Bot profile, or null for explicit token mode.
 * @property {string} smsSender - Infobip SMS sender.
 * @property {string} smsRecipients - Comma-delimited SMS recipients.
 * @property {string} emailRecipients - Comma-delimited Email recipients.
 * @property {string} notifyMessageTemplate - Notify message template.
 * @property {?number} lineNotifyCooldownMinutes - Line notify cooldown minutes.
 * @property {?number} lineNotifyMaxPerHour - LINE delivery-attempt limit per rolling hour.
 * @property {?number} lineNotifyMaxPerDay - LINE delivery-attempt limit per rolling day.
 * @property {?number} lineNotifyMaxPerMonth - LINE delivery-attempt limit per calendar month.
 * @property {?string} lineNotifyRateLimitProfileId - Shared LINE rate-limit Profile id.
 * @property {?number} smsNotifyCooldownMinutes - SMS notify cooldown minutes.
 * @property {?number} smsNotifyMaxPerHour - SMS recipient-attempt limit per rolling hour.
 * @property {?number} smsNotifyMaxPerDay - SMS recipient-attempt limit per rolling day.
 * @property {?number} smsNotifyMaxPerMonth - SMS recipient-attempt limit per calendar month.
 * @property {?string} smsNotifyRateLimitProfileId - Shared SMS rate-limit Profile id.
 * @property {?number} emailNotifyCooldownMinutes - Email notify cooldown minutes.
 * @property {?number} emailNotifyMaxPerHour - Email recipient-attempt limit per rolling hour.
 * @property {?number} emailNotifyMaxPerDay - Email recipient-attempt limit per rolling day.
 * @property {?number} emailNotifyMaxPerMonth - Email recipient-attempt limit per calendar month.
 * @property {?string} emailNotifyRateLimitProfileId - Shared Email rate-limit Profile id.
 */

/**
 * @typedef {Object} State
 * @property {Project[]} joinedProjects - The list of projects the user has joined.
 * @property {string} currentProjectId - The id of the currently selected project.
 */

/**
 * The initial project state.
 * @type {State}
 */
export const initialProjectState = {
    joinedProjects: [],
    currentProjectId: null
    //id: null,
    //projectName: null,
    //databaseName: null,
    //createdUtcTime: null,
    //createdByUser: null,
    //updatedByUser: null,
    //disabled: false,
    //description: null
};

/**
 * The project reducer.
 * @param {State} state - The current state.
 * @param {Object} action - The dispatched action.
 * @returns {State} The new state.
 */
const projectReducer = (state = initialProjectState, action) => {
    let p = action.payload;
    switch (action.type) {
        case 'SIGN_OUT':
        case 'CLEAR_PROJECT_STATE':
            return initialProjectState;
        case 'SET_JOINED_PROJECTS':
            return {
                ...state, //copying the original state
                // joinedProjects: [...state.joinedProjects, pSetter ]
                joinedProjects: p
            };
        case 'SET_CURRENT_PROJECT_ID':
            return {
                ...state,
                currentProjectId: p
            };
        case 'UPDATE_PROJECT_BY_ID_FROM_JOINED_PROJECTS':
            console.log("UPDATE_PROJECT_BY_ID_FROM_JOINED_PROJECTS");
            let newJoinedProjects = state.joinedProjects.map(proj => {
                if (proj.projectId === p.projectId) {
                    return {
                        ...proj,
                        ...p.newProjectInfo
                    };
                }
                return proj;
            });
            return {
                ...state,
                joinedProjects: newJoinedProjects,
                    
            };
        //case 'SET_TIME_HISTORY_QUERY_OPTIONS':
        //    return {
        //        ...state,
        //        timeHistoryQueryOptions: p
        //    }
        default:
            return state;
    }
};

export default projectReducer;
